
const dashboardMenu = [
  {
    "label": "Overview",
    "link": "/dashboard/overview#overview",
    "icon": "ri-pie-chart-2-line"
  },
  {
    "label": "Visit History",
    "link": "/dashboard/overview#visits",
    "icon": "ri-calendar-todo-line"
  },
  {
    "label": "Lab Results",
    "link": "/dashboard/overview#labs",
    "icon": "ri-shopping-bag-3-line"
  },
  {
    "label": "Vitals History",
    "link": "/dashboard/overview#vitals",
    "icon": "ri-bar-chart-2-line"
  },
  {
    "label": "Drugs & Prescription",
    "link": "/dashboard/overview#drugs",
    "icon": "ri-coin-line"
  },
   
  {
    "label": "Payment & Billing",
    "link": "/dashboard/overview#bills",
    "icon": "ri-bank-card-line"
  },
  {
    "label": "Immunization Chart",
    "link": "/dashboard/overview#immunization",
    "icon": "ri-coin-line"
  },
  // {
  //   "label": "Helpdesk Service",
  //   "link": "/dashboard/helpdesk",
  //   "icon": "ri-service-line"
  // },
  // {
  //   "label": "Storage Management",
  //   "link": "/dashboard/storage",
  //   "icon": "ri-hard-drive-2-line"
  // },
  // {
  //   "label": "Product Management",
  //   "link": "/dashboard/product",
  //   "icon": "ri-suitcase-2-line"
  // }
];

const applicationsMenu = [
  {
    "label": "Schedule Appointment",
    "link": "/appointment/schedule",
    "icon": "ri-calendar-todo-line"
  },
  {
    "label": "Upcoming Appointments",
    "link": "/dashboard/myappointment#upcoming",
    "icon": "ri-notification-line"
  },
  {
    "label": "Appointments History",
    "link": "/dashboard/myappointment#history",
    "icon": "ri-history-fill"
  },
  {
    "label": "Visit Summary",
    "link": "/dashboard/myappointment#summary",
    "icon": "ri-list-check-2",
    
  },
  // {
  //   "label": "Pre-visit Forms",
  //   "link": "/dashboard/previsit-form",
  //   "icon": "ri-question-answer-line"
  // },
  // {
  //   "label": "Contacts",
  //   "link": "/apps/contacts",
  //   "icon": "ri-contacts-book-line"
  // },
  // {
  //   "label": "Task Manager",
  //   "link": "/apps/tasks",
  //   "icon": "ri-checkbox-multiple-line"
  // },
  // {
  //   "label": "Media Gallery",
  //   "icon": "ri-gallery-line",
  //   "submenu": [
  //     {
  //       "label": "Music Stream",
  //       "link": "/apps/gallery-music"
  //     },
  //     {
  //       "label": "Video Stream",
  //       "link": "/apps/gallery-video"
  //     }
  //   ]
  // }
];

const pagesMenu = [
  // {
  //   "label": "Current Medications",
  //   "icon": "ri-account-circle-line",
  //   "link": "/medications/current"
  // },
  {
    "label": "Drug Mart",
    "link": "/medications#drug-mart",
    "icon": "ri-capsule-line"
  },
  {
    "label": "Purchased Drugs",
    "link": "/medications#purchased-drugs",
    "icon": "ri-coin-line"
    // "icon": "ri-line-height"
  },
  {
    "label": "Medications History",
    "icon": "ri-file-list-line",
    "link": "/medications#medications-history"
  },

  
  // {
  //   "label": "Allergies",
  //   "icon": "ri-account-circle-line",
  //   "link": "/page/allergies"
  // },

  // {
  //   "label": "Problem List",
  //   "icon": "ri-account-circle-line",
  //   "link": "/page/problem-list"
  // },

  // {
  //   "label": "Clinical Tasks",
  //   "icon": "ri-account-circle-line",
  //   "link": "/page/clinical-task"
  // },

  
  
];

const labMenu = [
  // {
  //   "label": "Lab Mart",
  //   "link": "/lab/request",
  //   "icon": "ri-flask-line"
  // }  ,
  {
    "label": "Lab",
    "link": "/examinations#mart",
   "icon": "ri-flask-line"
  },
  {
    "label": "Radiology",
    "link": "/examinations#radiology",
    "icon": "ri-first-aid-kit-line"
  },
  {
    "label": "Medical Report",
    "link": "/examinations#report",
    "icon": "ri-file-history-line"
  },
 
];


const DoctorsTabs = [
  {
    "label": "Patients",
    "icon": "ri-account-circle-line",
    "link": "/Doctors/AllPatients"
  },
  {
    "label": "Appointments",
    "icon": "ri-account-circle-line",
    "link": "/medications/history"
  },
  {
    "label": "---",
    "icon": "ri-account-circle-line",
    "link": "/medications/history"
  },  
  {
    "label": "Visit Summary",
    "icon": "ri-pencil-ruler-2-line",
    "link": "history-vissit-summary"
    
  },
  
  
];


const uiElementsMenu = [

  {
    "label": "Your Invoice",
    "icon": "ri-bank-card-line",
    "link": "/bills#invoices"
    
  },
  {
    "label": "Claims",
    "icon": "ri-suitcase-line",
    "link": "/bills#claims"
    
  },
  {
    "label": "Payment HIstory",
    "icon": "ri-wallet-2-line",
    "link": "/bills#payment-history"
    
  },
  // {
  //   "label": "Costs Estimates",
  //   "icon": "ri-bar-chart-2-line",
  //   "link": "bills/costsEstimates"
    
  // },
];

const myDocumentsMenu = [
  {
    "label": "My Documents",
    "icon": "ri-file-line",
    "link": "page/documents"
    
  },
  {
    "label": "Excuse Duty",
    "icon": "ri-file-paper-line",
    "link": "page/excuse-duty"
  },
 
 ]

const apps = [
  // {
  //   "label": "Support",
  //   "icon": "ri-chat-3-line",
  //   "link": "apps/chat"
    
  // },
   {
    "label": "AI Support",
    "icon": "ri-chat-3-line",
    "link": "dashboard/support"
  }
]
const Histroy = [
  {
    "label": "Antenatal History",
    "icon": "ri-pencil-ruler-2-line",
    "link": "history/antenatal"
    
  },
 
  {
    "label": "Admission History",
    "icon": "ri-pencil-ruler-2-line",
    "link": "history/admission"
    
  },
  {
    "label": "Labour History",
    "icon": "ri-account-circle-line",
    "link": "/page/labour-history"
  },
  {
    "label": "Ivf History",
    "icon": "ri-account-circle-line",
    "link": "/page/ivf-history"
  },

]

export { dashboardMenu,apps, DoctorsTabs, Histroy, applicationsMenu, pagesMenu, uiElementsMenu, myDocumentsMenu, labMenu };